import { ItemTypes } from '../constants/constants';
import { isOptionalTextValueEmpty } from './address';
import { hasVariableBoxError, isOptionalBoxEmpty } from './boxes';
import { sortAndFilterVariablesGroupedByContainer } from './variableOrderArray';
import {
  getVariablesGroupedByContainer,
  shouldHideRowInForm,
} from './variables';

// Ligne du formulaire dont une variable optionnelle est restée vide. Un
// groupement l'est dès qu'une de ses variables utilisées l'est.
export const hasOptionalEmptyValue = (record, variables = {}) => {
  if (record.type === ItemTypes.CUSTOM_TEXT_VARIABLE) {
    return isOptionalTextValueEmpty(variables, record.id, record.value);
  }
  if (record.type === ItemTypes.VARIABLE_GROUP) {
    return !!record.variableIds?.some((vId) =>
      variables[vId] && !variables[vId].notUsed && isOptionalTextValueEmpty(variables, vId));
  }
  return isOptionalBoxEmpty(record);
};

// Lignes affichées dans le formulaire, hors variables inutilisées.
const formVariableBoxes = ({
  variablesGroupedByContainer,
  variableOrderArray,
  isTemplate,
  sectionList,
}) =>
  sortAndFilterVariablesGroupedByContainer({
    variablesGroupedByContainer,
    variableOrderArray,
    filterHiddenBoxes: !isTemplate,
  })
    .filter(
      (vInfos) => isTemplate || !shouldHideRowInForm({ vInfos, sectionList })
    )
    .flatMap((vInfos) => vInfos.variablesBoxes.filter((b) => !b.notUsed));

// Le formulaire a-t-il des valeurs manquantes ? C'est ce que signale le point
// d'exclamation du panneau gauche, et ce dont peut dépendre le filigrane.
export const hasFormMissingValues = ({ variables, ...form }) =>
  formVariableBoxes(form).some((b) => hasVariableBoxError(b, variables).error);

// Le formulaire a-t-il des variables optionnelles restées vides ? Simple
// repère dans le panneau gauche : elles ne déclenchent pas le filigrane.
export const hasFormOptionalEmptyValues = ({ variables, ...form }) =>
  formVariableBoxes(form).some((b) => hasOptionalEmptyValue(b, variables));

// Même calcul depuis l'état du store, pour une proposition.
export const proposalHasMissingValues = (state, sectionList) =>
  hasFormMissingValues({
    variablesGroupedByContainer: getVariablesGroupedByContainer({
      variableGroups: state.variableGroups,
      variables: state.variables,
      boxes: [...state.boxes, ...state.masks.flatMap((m) => m.boxes)],
      containers: state.containers,
      columns: state.columns,
      rowContainers: state.rowContainers,
    }),
    variableOrderArray: state.variableOrderArray,
    variables: state.variables,
    isTemplate: false,
    sectionList,
  });
